import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  MenuItem,
  Typography,
} from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import VehicleDetailsService from "src/service/vehicleDetails";
import VehicleCategoryService from "src/service/vehicleCategory";
import WheelTypeService from "src/service/wheel";
import swal from "sweetalert";
import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
import { IconArrowBack } from "@tabler/icons";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Update Vehicle Details ",
  },
];

const validationSchema = yup.object({
  vehicle_category_id: yup
    .string("vehicle category number")
    .required("vehicle category number is required"),

  vehicle_wheel_id: yup
    .string("vehicle wheel type number")
    .required("vehicle wheel type number is required"),

  vehicle_no: yup
    .string("Vahichle number")
    .min(10, "Vahichle number should be of minimum 10 length")
    .max(10, "Vahichle number should be of maximum 10 in length")
    .required("Vahichle number is required"),

  make: yup
    .string("Enter Vehicle Company")
    .min(2, "Vehicle Company should be of minimum 2 length")
    .max(30, "Vehicle Company should be of maximum 30 in length")
    .required("Vehicle Company is required"),

  model: yup
    .string("vehicle model")
    .min(2, "vehicle model should be of minimum 2 length")
    .max(30, "vehicle model should be of maximum 30 in length")
    .required("vehicle model is required"),
});

const UpdateVehicleDetails = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const param = useParams();

  const navigate = useNavigate();
  const [vehicleCat, setVehicleCategory] = useState([]);
  const [wheel, setWheelType] = useState([]);

  const fetchVehicleData = async () => {
    try {
      // get vehicle category
      const res2 = await VehicleCategoryService.getVehicleCategory({});

      // get wheel type
      const res3 = await WheelTypeService.getWheelType({});

      setVehicleCategory(res2.data);
      setWheelType(res3.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    vehicle_category_id: "",
    vehicle_wheel_id: "",
    vehicle_no: "",
    make: "",
    model: "",
    d_by: sessionData.data.id,
  });

  useEffect(() => {
    const fetchplanSubsData = async () => {
      try {
        const res = await VehicleDetailsService.getVehicleDetails({
          id: param.id,
        });

        setInitialValues(res.data);
        // Update the initialValues once data is fetched
        setInitialValues({
          id: param.id,
          vehicle_category_id: res.data[0].vehicle_category_id,
          vehicle_wheel_id: res.data[0].vehicle_wheel_id,
          vehicle_no: res.data[0].vehicle_no,
          make: res.data[0].make,
          model: res.data[0].model,
          d_by: sessionData.data.id,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchplanSubsData();
    fetchVehicleData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param.id, sessionData.data.id, sessionData.data.user_type]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const res = await VehicleDetailsService.updateVehicleDetails(values);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/vehicleDetailsLists");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  // =============================

  return (
    <div>
      <Breadcrumb title=" Update Vehicle Details " items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update Vehicle Details
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/vehicleDetailsLists");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            {/* <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="vehicle_category_id">
                Vehicle Category <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomSelect
                id="vehicle_category_id"
                name="vehicle_category_id"
                value={values.vehicle_category_id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.vehicle_category_id &&
                  Boolean(errors.vehicle_category_id)
                }
                fullWidth
                variant="outlined"
              >
                <MenuItem value="">--select--</MenuItem>
                {vehicleCat.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.vehicle_name}
                  </MenuItem>
                ))}
              </CustomSelect>
            </Grid> */}

            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="fs-language">
                Vehicle Category <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_category_id"
                name="vehicle_category_id"
                options={vehicleCat}
                getOptionLabel={(option) => option.vehicle_name}
                value={
                  vehicleCat.find(
                    (option) => option.id === values.vehicle_category_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "vehicle_category_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={
                      touched.vehicle_category_id &&
                      Boolean(errors.vehicle_category_id)
                    }
                    helperText={
                      touched.vehicle_category_id && errors.vehicle_category_id
                    }
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a vehicle category"
                  />
                )}
              />
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="vehicle_wheel_id">
                Vehicle Wheel Type <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomSelect
                id="vehicle_wheel_id"
                name="vehicle_wheel_id"
                value={values.vehicle_wheel_id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.vehicle_wheel_id && Boolean(errors.vehicle_wheel_id)
                }
                fullWidth
                variant="outlined"
              >
                <MenuItem value="">--select--</MenuItem>
                {wheel.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.wheel_type}
                  </MenuItem>
                ))}
              </CustomSelect>
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="vehicle_no">
                Vehicle Number <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="vehicle_no"
                name="vehicle_no"
                type="text"
                value={values.vehicle_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.vehicle_no && Boolean(errors.vehicle_no)}
                helperText={touched.vehicle_no && errors.vehicle_no}
                variant="outlined"
                placeholder="Enter vehicle number"
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="make">
                Make <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="make"
                name="make"
                type="text"
                value={values.make}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.make && Boolean(errors.make)}
                helperText={touched.make && errors.make}
                variant="outlined"
                placeholder="Enter vehicle number"
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="model">
                Model <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="model"
                name="model"
                type="text"
                value={values.model}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.model && Boolean(errors.model)}
                helperText={touched.model && errors.model}
                variant="outlined"
                placeholder="Enter vehicle number"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid
            item
            lg={6}
            md={12}
            sm={12}
            xs={12}
            style={{ marginTop: "20px" }}
          >
            <Button color="primary" variant="contained" type="submit">
              Update
            </Button>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default UpdateVehicleDetails;
